export default {
  API: '0005',
  DUPLICATED_EMAIL: '0007'
};
